import { css, SerializedStyles } from '@emotion/react'
import { IStyles } from '../../context/Styles';

export const printStyles = (styles: IStyles): SerializedStyles => css`
`;